"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthState = void 0;
exports.WriteAuthMetadata = WriteAuthMetadata;
exports.RemoveAuthMetadata = RemoveAuthMetadata;
exports.GetAuthMetadata = GetAuthMetadata;
var response_1 = require("@ca/wrap-sdk/src/response");
var item_io_1 = require("../item-io");
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
var time_1 = require("@ca/time");
var AuthState;
(function (AuthState) {
    AuthState["START"] = "START";
    AuthState["OTP"] = "OTP";
    AuthState["OTP_2"] = "OTP_2";
    AuthState["TOO_MANY_LOGIN_ATTEMPTS"] = "TOO_MANY_LOGIN_ATTEMPTS";
    AuthState["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    AuthState["LOGIN_NEW_PASSWORD"] = "LOGIN_NEW_PASSWORD";
})(AuthState || (exports.AuthState = AuthState = {}));
var ITEM_PARTITION = "auth-metadata";
var AUTH_METADATA_EXPIRY_SEC = 30 * 60;
var FAILED_LOGIN_EXPIRY_SEC = 30 * 60;
var OTP_EXPIRY_SEC = 10 * 60;
var TOKEN_EXPIRY_SEC = 10 * 60;
function WriteAuthMetadata(creds, metadata) {
    return __awaiter(this, void 0, void 0, function () {
        var table;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    table = (0, item_io_1.GetSaTable)();
                    metadata.TTL = (0, time_1.get_now_sec)() + AUTH_METADATA_EXPIRY_SEC;
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchWriteC)(creds, (_a = {}, _a[table] = [metadata], _a))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function RemoveAuthMetadata(creds, username) {
    return __awaiter(this, void 0, void 0, function () {
        var table, key;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    table = (0, item_io_1.GetSaTable)();
                    key = {
                        partition: ITEM_PARTITION,
                        id: username,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchDeleteC)(creds, (_a = {}, _a[table] = [key], _a))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function GetAuthMetadata(creds, username) {
    return __awaiter(this, void 0, void 0, function () {
        var table, key, b_resp, item, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    table = (0, item_io_1.GetSaTable)();
                    key = {
                        partition: ITEM_PARTITION,
                        id: username,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(creds, table, [key])];
                case 1:
                    b_resp = _a.sent();
                    if (b_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(b_resp)];
                    }
                    item = {
                        state: AuthState.START,
                        partition: ITEM_PARTITION,
                        id: username,
                        failed_login_sec: [],
                        OTP: [],
                        otp_fail: 0,
                        TTL: 0,
                    };
                    if (b_resp.payload.length === 1) {
                        item = b_resp.payload[0];
                    }
                    RemoveExpiredItems(item);
                    if (!(item.state === AuthState.OTP && item.OTP.length === 0)) return [3 /*break*/, 3];
                    // OTP items expired! Revert back to START state.
                    item.state = AuthState.START;
                    return [4 /*yield*/, WriteAuthMetadata(creds, item)];
                case 2:
                    resp = _a.sent();
                    if (resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, resp];
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/, (0, response_1.SuccessResponse)(item)];
            }
        });
    });
}
function RemoveExpiredItems(item) {
    var now_sec = (0, time_1.get_now_sec)();
    item.failed_login_sec = item.failed_login_sec.filter(function (num) { return num > now_sec - FAILED_LOGIN_EXPIRY_SEC; });
    item.OTP = item.OTP.filter(function (otp) { return otp.timestamp_sec > now_sec - OTP_EXPIRY_SEC; });
    if (item.token_timestamp_sec
        && item.token_timestamp_sec < now_sec - TOKEN_EXPIRY_SEC) {
        item.token_timestamp_sec = undefined;
        item.id_token = undefined;
        item.refresh_token = undefined;
    }
}
//# sourceMappingURL=auth-metadata.js.map